import React from "react";

const Contact = () => {
  // console.log(this.props.location.param1);
  // const GetDate = () => {
  // const location = useLocation();
  // const selDate = location.state.date;
  // console.log(selDate);

  return (
    <div className="m-2 p-4 border text-center">
      <h2>Akwaaba</h2>
      <p>
        Princess May Primary School <br /> Barrett's Grove Entrance (off Stoke
        Newington Road) <br /> N16 8AJ
      </p>

      <p className="mt-4">
        Please send us email and follow us on social media from the link below
      </p>
    </div>
  );
};

export default Contact;
